import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Input as InputKubit } from '@kubit/web-ui-components/input';
import { ScreenReaderOnly } from '@kubit/web-ui-components/screenReaderOnly';
import * as React from 'react';
import { TextCountVariantType } from '../../designSystem/reloaded/commons/components/variants';
import { TEXT_COUNT_MAX_LENGTH } from '../textCount/textCountStandAlone';
import { TextCount } from './../textCount/textCount';
import { buildScreenReaderText, getCharactersLength } from './utils/counter.utils';
const SCREEN_REEDER_CURRENT_CHARACTERS_ID = 'screenReaderCurrentCharactersId';
export const Input = React.forwardRef(({ showTextCount = true, ...props }, ref) => {
    const inputRef = React.useRef();
    const [value, setValue] = React.useState(props.value || '');
    const [showMessage, setShowMessage] = React.useState(false);
    // Expose the ref to the parent component
    React.useImperativeHandle(ref, () => inputRef.current, []);
    React.useEffect(() => {
        setValue(props.value || '');
    }, [props.value]);
    const currentCharacters = React.useMemo(() => {
        return getCharactersLength(value, inputRef);
    }, [value]);
    const handleChange = e => {
        setValue(e.target.value);
        props.onChange?.(e);
        setShowMessage(false);
    };
    const handleBlur = e => {
        props.onBlur?.(e);
        setShowMessage(true);
    };
    return (_jsxs(_Fragment, { children: [_jsx(InputKubit, { ...props, ref: inputRef, "aria-describedby": showMessage && showTextCount ? SCREEN_REEDER_CURRENT_CHARACTERS_ID : undefined, textCounter: showTextCount ? (_jsx(TextCount, { currentCharacters: currentCharacters, disabled: props.disabled, variant: TextCountVariantType.DEFAULT, ...props.textCount, maxLength: props.maxLength ?? props.textCount?.maxLength })) : undefined, onBlur: handleBlur, onChange: handleChange }), showTextCount && (_jsx(ScreenReaderOnly, { id: SCREEN_REEDER_CURRENT_CHARACTERS_ID, children: buildScreenReaderText(value, inputRef, props.textCount?.maxLength ?? TEXT_COUNT_MAX_LENGTH, props.screenReaderCurrentCharacters) }))] }));
});
Input.displayName = 'Input';
//# sourceMappingURL=input.js.map